<template>
  <div class="releasePass_wrapper">
    <div class="warning_con" v-if="showPage">{{ showPage }}</div>
    <div v-else id="releasePass_conent">
      <div class="content_header">
        <div class="title">物品/货物放行</div>
        <div class="subTitle">对于园区物品/货物进园区开具电子放行条</div>
      </div>
      <div class="content">
        <div class="content_item">
          <div class="item_title">
            放行信息
            <van-field
              style="width: 140px"
              @click="showTime"
              readonly
              v-model="releaseDate"
              placeholder="请选择时间"
              right-icon="arrow-down"
            />
          </div>
          <div class="item_content">
            <div
              class="item_content_list"
              v-for="(item, index) in releaseInfo"
              :key="index"
              :style="{
                width: item.show ? 100 + '%' : 0
              }"
            >
              <div v-if="item.show" class="list_item">
                <div :class="index == 0 ? 'icon' : 'icon1'">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="item_name">{{ item.name }}</div>
                <div class="item_num">{{ item.value }}</div>
              </div>
            </div>
          </div>
          <div class="footer" @click="goHistory">查看历史记录>></div>
        </div>
        <div class="content_item">
          <div class="item_title">放行类型</div>
          <div class="item_content1">
            <div
              class="type_item"
              v-for="(item, index) in numList"
              :key="index"
            >
              <div class="item_sub" @click="toUrl(item)" v-if="item.show">
                <div class="left">{{ item.value }}</div>
                <div class="right">
                  <div class="name">
                    {{ item.name }} <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="date"
        type="date"
        title="选择日期"
        @confirm="comfirmTime"
        @cancel="showDate = false"
      />
    </van-popup>
  </div>
</template>

<script>
import api from "@/apis";
import { getToken } from "@/utils/cookie";
import apiLogin from "@/apis";
import moment from "moment";
export default {
  name: "releasePass",
  data() {
    return {
      releaseInfo: [
        {
          icon: require("@/assets/visitor/icon1.png"),
          name: "车辆放行",
          value: "0",
          show: false
        },
        {
          icon: require("@/assets/visitor/icon2.png"),
          name: "物品放行",
          value: "0",
          show: true
        },
        {
          icon: require("@/assets/visitor/icon3.png"),
          name: "其他放行",
          value: "0",
          show: true
        }
      ],
      numList: [
        {
          name: "车辆放行",
          value: "仓库装货车辆放行",
          path: `/releaseApply?type=1&show=${
            this.$route.query.show == "true" ? true : false
          }`,
          show: false
        },
        {
          name: "物品放行",
          value: "员工物品放行",
          path: `/releaseApply?type=2&show=${
            this.$route.query.show == "true" ? true : false
          }`,
          show: true
        },
        {
          name: "其他放行",
          value: "其他物品放行",
          path: `/releaseApply?type=3&show=${
            this.$route.query.show == "true" ? true : false
          }`,
          show: true
        }
      ],
      showPage: "",
      showWarning: "",
      parkIds: "",
      releaseDate: moment(new Date()).format("YYYY-MM-DD"),
      date: new Date(),
      showDate: false,
      username:''
    };
  },
  created() {
    this.showPage = "权限获取中";
    let token = getToken();
    console.log(token);
    if (token) {
      this.username = token;
      // this.queryUsername(token);
      this.queryRole(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          console.log(res);
          this.username = res;
          this.queryRole(res);
          // this.queryUsername(res);
        });
      });
    }
  },
  mounted() {
    // if (this.$route.query.show == "true") {
    //   console.log(111111111);
    //   this.numList[1].list[0].show = false;
    // }
  },
  methods: {
    // 查询角色
    queryRole(username) {
      api.queryRoleApi({ username }).then(res => {
        if (res.code == 200) {
          // console.log(33333, res);
          if (this.$route.query.show == "true") {
            // this.releaseInfo[0].show = true;
            // this.numList[0].show=true
            this.showPage = "";
            this.parkIds = res.data.map(item => item.parkIds).join(",");
            sessionStorage.setItem("parkIds", JSON.stringify(this.parkIds));
          } else {
            if (res.data.length == 0) {
              this.showPage = "暂无权限，请联系管理员";
            } else {
              this.dataType = res.data.map(item => item.dataType);
              this.parkIds = res.data.map(item => item.parkIds).join(",");
              sessionStorage.setItem("dataType", JSON.stringify(this.dataType));
              sessionStorage.setItem("parkIds", JSON.stringify(this.parkIds));
              // 权限包含 3 4 时 可以看到车辆放行 ，为2时只能从 员工自助进入 ，为1时没有放行条权限
              if (this.dataType.includes(4) || this.dataType.includes(3)) {
                this.releaseInfo[0].show = true;
                this.numList[0].show = true;
                this.showPage = "";
              } else if (this.dataType.includes(2)) {
                if (this.$route.query.show == "true") {
                  this.releaseInfo[0].show = false;
                  this.numList[0].show = false;
                  this.showPage = "";
                } else {
                  this.$router.replace("/mobile/home");
                }
              } else {
                this.showPage = "暂无权限，请联系管理员";
              }
            }
          }

          this.queryReleaseTypeSum();
        }
      });
    },
    // 查询放行信息
    queryReleaseTypeSum() {
      api
        .queryReleaseTypeSum({
          parkIdStr: this.parkIds,
          releaseDate: this.releaseDate,
          username:this.username 
        })
        .then(res => {
          if (res.code == 200) {
            this.releaseInfo[0].value = res.data.leaveReleased;
            this.releaseInfo[1].value = res.data.releasedAdd;
            this.releaseInfo[2].value = res.data.generalAdd;
          }
        });
    },
    // 跳转
    toUrl(item) {
      if (item.path) {
        this.$router.push(item.path);
      }
    },
    //跳转历史记录
    goHistory() {
      this.$router.push({
        path: "/releaseList"
      });
    },
    // 获取hrToken
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;;
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取用户信息
    queryUsername(token) {
      api
        .queryByUsername({
          username: token
        })
        .then(({ data }) => {
          this.queryRole(data.username);
        });
    },
    // 显示时间
    showTime() {
      this.showDate = true;
    },
    //确认时间
    comfirmTime(value) {
      this.releaseDate = moment(value).format("YYYY-MM-DD");
      this.showDate = false;
      this.queryReleaseTypeSum();
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #releasePass_conent {
    width: 100%;
  }
  ::v-deep .van-popup {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #releasePass_conent {
    width: 276px * $zoom;
  }
  ::v-deep .van-popup {
    width: 276px * $zoom;
    left: initial;
  }
}
.releasePass_wrapper {
  display: flex;
  justify-content: center;
  .warning_con {
    line-height: 100vh;
    font-size: 27px;
  }
  #releasePass_conent {
    font-size: 16px * $zoom;
    position: relative;
    background-color: #f7f9fa;
    height: 100vh;
    .content_header {
      width: 100%;
      height: 128px * $zoom;
      background-image: url("~@/assets/visitor/bac.png");
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .title {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: bold;
        font-size: 12px * $zoom;
        color: #282b32;
        padding-left: 10.5px * $zoom;
      }
      .subTitle {
        width: 350px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 9px * $zoom;
        color: #282b32;
        padding-left: 10.5px * $zoom;
        margin-bottom: 20px * $zoom;
        margin-top: 10px * $zoom;
        display: flex;
        flex-wrap: wrap;
      }
    }
    .content {
      width: 100%;
      padding: 10.5px * $zoom;
      .content_item {
        width: 100%;
        padding: 10.5px * $zoom;
        background: #ffffff;
        box-shadow: 0px 1px * $zoom 8px * $zoom 0px rgba(0, 0, 0, 0.08);
        border-radius: 6px * $zoom;
        margin-bottom: 12px * $zoom;
        &:last-child {
          margin-bottom: 0;
        }
        .item_title {
          font-weight: 800;
          font-size: 10.5px * $zoom;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: space-between;
          ::v-deep {
            .van-field__body {
              font-weight: 500 !important;
            }
          }
        }
        .item_content {
          display: flex;
          justify-content: space-around;
          margin-top: 8px * $zoom;
          background: rgba(78, 162, 124, 0.04);
          border-radius: 7px;
          border: 1px solid rgba(78, 162, 124, 0.32);
          padding: 25px 0;
          .item_content_list {
            .list_item {
              display: flex;
              flex-direction: column;
              align-items: center;
              .icon {
                img {
                  width: 37px;
                  height: 29px;
                }
              }
              .icon1 {
                img {
                  width: 29px;
                  height: 29px;
                }
              }
              .item_name {
                font-weight: 400;
                font-size: 26px;
                color: #666666;
                margin: 5px 0 10px 0;
              }
              .item_num {
                font-weight: 800;
                font-size: 33px;
                color: #388654;
              }
            }
          }
        }
        .footer {
          font-weight: 400;
          font-size: 26px;
          color: #999999;
          margin-top: 20px;
          text-align: right;
        }

        .item_content1 {
          .type_item {
            &:last-child .item_sub {
              border-bottom: 0;
            }
            .item_sub {
              display: flex;
              justify-content: space-between;
              height: 95px;
              line-height: 95px;
              border-bottom: 2px solid #eeeeee;

              .left {
                font-weight: 400;
                font-size: 27px;
                color: #666666;
              }
              .right {
                .name {
                  font-weight: 600;
                  font-size: 28px;
                  color: #388654;
                  ::v-deep {
                    .el-icon-arrow-right {
                      font-weight: bold;
                      margin-left: 10px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
